/*jslint browser: true */
/*global window, require */

const Cookies = require('js-cookie');

module.exports = function()
{
	'use strict';
	const self = this || {};
	const winAlias = window;
	const prefix = "lec_";
	const expiry = 90;
	let storage;

	self.getAny = function(name)
	{
		let val = false;
		val = self.getCookie(name);

		if (!val)
			val = self.getStorage(name);

		return val;
	};

	self.getCookie = function(name)
	{
		return Cookies.get(prefix + name);
	};

	self.setCookie = function(name, value)
	{
		return Cookies.set(prefix + name, value, { expires: expiry });
	};

	self.setCookieTemp = function(name, value)
	{
		return Cookies.set(prefix + name, value);
	};

	self.supportsStorage = function()
	{
		if (storage !== undefined)
			return storage;

		try {
			const x = 'storage_test';
			winAlias.localStorage.setItem(x, x);
			winAlias.localStorage.removeItem(x);
			return true;
		} catch (e) {
			return e instanceof DOMException && (
				e.code === 22 ||
				e.code === 1014 ||
				e.name === 'QuotaExceededError' ||
				e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
				(winAlias.localStorage && winAlias.localStorage.length !== 0);
		}
	};

	self.getStorage = function (name)
	{
		if (!self.supportsStorage())
			return false;
		return winAlias.localStorage.getItem(prefix + name);
	};

	self.setStorage = function (name, value)
	{
		if (!self.supportsStorage())
			return false;
		if (typeof value !== "string")
			value = JSON.stringify(value);
		return winAlias.localStorage.setItem(prefix + name, value);
	};

	storage = self.supportsStorage();

	return self;
}();
